import { ReactNode, useCallback } from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { oidcConfig } from '@/lib/auth/oidc-config';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * 認証プロバイダー
 * react-oidc-contextのAuthProviderをラップし、ワークスペース認証チェックを実装
 */
export function AuthProvider({ children }: AuthProviderProps) {
  /**
   * サインインコールバック
   * 認証成功後に呼び出される（URLからstateパラメータを削除するなど）
   * ワークスペース認証チェックはCallbackPageで実行
   */
  const onSigninCallback = useCallback(() => {
    // URLからOIDC関連のクエリパラメータを削除
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      url.searchParams.delete('code');
      url.searchParams.delete('state');
      url.searchParams.delete('session_state');
      window.history.replaceState({}, '', url.pathname);
    }
  }, []);

  return (
    <OidcAuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      {children}
    </OidcAuthProvider>
  );
}
